
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/burgerman",
      function () {
        return require("private-next-pages/case-study/burgerman.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/burgerman"])
      });
    }
  